export default __webpack_public_path__ + "fonts/fullscreen.svg";